import byIdMaker from 'reducersMakers/byIdMaker';
import * as actions from 'actions';

export default byIdMaker({
  fetchSuccessTypes: [actions.CATEGORIES_FETCH_SUCCESS],
  entityType: 'categories'
});



/** WEBPACK FOOTER **
 ** ./src/members/state/categories/byId/reducer.js
 **/